import { ToolOptionsProps } from '../ToolOptionsRenderer.types';
import { ToolOptionsRendererProps } from '../../../BaseToolbar.types';
import { useStore } from 'src/contexts/StoreContext';
import { useMemo } from 'react';
import { useToolOptionsRendererLogic } from '../ToolOptionsRenderer.logic';
import { getToolOptionGroupI18nKey } from 'src/_shared/utils/getI18nKeys';

export const NO_GROUP = 'NO_GROUP';

export const useGroupedImageToolOptionsLogic = ({
  options,
  ...otherProps
}: ToolOptionsRendererProps<ToolOptionsProps>) => {
  const {
    project: { activeGroup, groupCode },
  } = useStore();
  const groupedOptionsEntries = useMemo(() => {
    const hasNoReferencingOtherGroupCode = options.every(
      (option: ToolOptionsProps) => !option.referencingOtherGroupCode,
    );

    return Object.entries(
      options.reduce<Record<string, ToolOptionsProps[]>>((acc, option) => {
        const group = hasNoReferencingOtherGroupCode
          ? NO_GROUP
          : getToolOptionGroupI18nKey(
              option.productOptionCode,
              activeGroup?.code ?? groupCode,
              option.referencingOtherGroupCode,
            );
        const oldAcc = acc[group] ?? [];
        return {
          ...acc,
          [group]: [...oldAcc, option],
        };
      }, {}),
    );
  }, [options, activeGroup, groupCode]);

  const { scrollViewRef, getScrollViewElementTestId, isOptionSelected, onPressAndSelectToolOption } =
    useToolOptionsRendererLogic({
      ...otherProps,
      options: groupedOptionsEntries.map(([_, options]) => options).flat(),
    } as ToolOptionsRendererProps<ToolOptionsProps>);

  return {
    groupedOptionsEntries,
    scrollViewRef,
    getScrollViewElementTestId,
    isOptionSelected,
    onPressAndSelectToolOption,
  };
};
